<template>
	<div>
		<az-container>
			<v-row>
				<v-col cols="12" sm="7" class="d-flex justify-start">
					<menu-acoes
						v-if="temPermissao && totalItens > 0"
						class="acessar-ata-itens-btn-mais-acoes"
						:nome-botao="menuAcoesItens.nome"
						:nome="menuAcoesItens.nome"
						cor-icone="--v-error-base"
						icone-primary="add_circle"
						icone-secondary="arrow_drop_down"
						:acoes-menu="menuAcoesItens.itens"
						tamanho-icone-primary="0.9rem"
						tamanho-icone-secondary="0.9rem"
						tamanho-icone-menu="18px"
						@adicionar-documento="adicionarDocumento"
						@adicionar-anexo="adicionarAnexo"
					>
					</menu-acoes>
				</v-col>
				<v-col cols="12" sm="5" class="d-flex justify-end">
					<az-search
						simple-search-placeholder="Busque por título ou autor"
						:filter="filtro"
						@simple-search="buscar"
						@remove-filter="removerFiltros"
					></az-search>
				</v-col>
			</v-row>
		</az-container>
		<v-divider></v-divider>
		<az-container>
			<v-row>
				<v-col cols="12">
					<template-listagem-documentos-vazia
						:total-itens="totalItens"
						:has-authority="temPermissao"
						:menu-acoes-itens="menuAcoesItens"
						:funcao-adicionar-documento="adicionarDocumento"
						:funcao-adicionar-anexo="adicionarAnexo"
					></template-listagem-documentos-vazia>
					<listagem-documentos
						:total-paginas="totalPaginas"
						:paginacao="paginacao"
						:total-itens="totalItens"
						:documentos="documentos"
						:tipo-documento="tipoDocumento"
						:atualiza-listagem="chaveAtualizacaoListagem"
						:coluna-titulo-habilitada="colunaTituloHabilitada"
						:coluna-acoes-habilitada="colunaAcoesHabilitada"
						:coluna-convidados-habilitada="colunaConvidadosHabilitada"
						:coluna-data-habilitada="colunaDataHabilitada"
						:coluna-juntado-habilitada="colunaJuntadoHabilitada"
						:usuario-possui-permissao-para-juntar="usuarioPossuiPermissaoParaJuntar"
						:permissao-redigir="permissaoRedigir"
						:permissao-juntar="permissaoJuntar"
						:permissao-concluir-edicao-documento="permissaoConcluirEdicaoDocumento"
						:permissao-assinar-eletronicamente="permissaoAssinarEletronicamente"
						:permissao-assinar-digitalmente="permissaoAssinarDigitalmente"
						:permissao-excluir-documento="permissaoExcluirDocumento"
						:permissao-baixar-documento="permissaoBaixarDocumento"
						:permissao-convidar-signatarios="permissaoConvidarSignatarios"
						:permissao-cancelar-documento="permissaoCancelarDocumento"
						:permissao-desentranhar-documento="permissaoDesentranharDocumento"
						:permissao-pncp-enviar="permissaoPncpEnviar"
						:permissao-pncp-excluir="permissaoPncpExcluir"
						@paginar="setPaginacaoListagem"
						:is-editar="isEditar"
						:exibir-acoes-pncp="exibirAcoesPncp"
						:has-authority="temPermissao"
						@resetar-page="resetarPaginaListagem"
						@carregar-listagem="carregarDocumentos"
						@abrir-modal-selecionar-tipo-assinatura="abrirModalSelecionarTipoAssinatura"
						@convidar-signatarios="tratarEventoConvidarSignatarios"
						@visualizar-signatarios="tratarEventoVisualizarSignatarios"
						@continuar-elaboracao-termo-desentranhamento="
							tratarEventoContinuarElaboracaoTermoDesentranhamento
						"
						@criar-termo-desentranhamento="tratarEventoCriarTermoDesentranhamento"
						:exibir-acoes-processo-digital="exibirAcoesProcessoDigital"
					></listagem-documentos>
				</v-col>
			</v-row>
		</az-container>
		<div>
			<modal-adicionar-documentos-generico
				:tipo-documento="tipoDocumento"
				:id-entidade="Number($route.params.id)"
				:exibir="exibirModalAdicionarDocumentos"
				@fechar-modal="fecharModaladicionar"
			></modal-adicionar-documentos-generico>

			<modal-adicionar-anexos-generico
				:tipo-documento="tipoDocumento"
				:exibir="exibirModalAdicionarAnexos"
				:id-entidade="Number($route.params.id)"
				:repositorio-flowbee="repositorioFlowbee"
				@fechar-modal="fecharModalAdicionarAnexo"
				:id-pasta-externa-digital="idPastaExternaDigital"
			></modal-adicionar-anexos-generico>

			<modal-selecao-tipo-assinatura-generico
				v-if="exibirModalSelecaoAssinatura"
				:exibir="exibirModalSelecaoAssinatura"
				:permissao-assinatura-eletronica="permissaoAssinarEletronicamente"
				:permissao-assinatura-digital="permissaoAssinarDigitalmente"
				@fechar-modal="fecharModalSelecionarTipoAssinatura"
				@assinar-eletronicamente="realizarAssinaturaEletronica"
				@assinar-digitalmente="realizarAssinaturaDigital"
			></modal-selecao-tipo-assinatura-generico>

			<formulario-assinatura-convite
				v-if="exibirModalConvidarSignatarios"
				:exibir-modal="exibirModalConvidarSignatarios"
				:titulo-modal="tituloModal"
				:titulo-documento="tituloDocumento"
				:id-associacao="idAssociacao"
				@fechar-modal="fecharModal"
				@confirmar-signatarios="convidarSignatarios"
				@excluir-signatario="tratarEventoExcluirSignatario"
				:func-buscar="buscarSignatarios"
			></formulario-assinatura-convite>

			<modal-confirmacao
				:titulo-modal="tituloModal"
				:mensagem="mensagemConfirmacaoModal"
				:subtitulo-modal="subtituloConfirmacaoModal"
				:exibir="exibirModalConfirmacao"
				@confirmar="confirmarAcaoModal"
				@fechar-modal="fecharAcaoModal"
			>
			</modal-confirmacao>

			<modal-assinatura-signatario
				v-if="exibirModalSignatarios"
				:signatarios="signatarios"
				:exibir="exibirModalSignatarios"
				:titulo="tituloModal"
				@fechar-modal="fecharModalSignatarios"
			>
			</modal-assinatura-signatario>
		</div>
	</div>
</template>
<script>
import TemplateListagemDocumentosVazia from '@/views/components/documentos/controle-documentos/template-listagem-documento-vazia/TemplateListagemDocumentosVazia.vue'
import ListagemDocumentos from '@/views/components/documentos/controle-documentos/listagem-documentos/ListagemDocumentos.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes, mutationTypes, situacoes, routesNames } from '@/core/constants'
import ModalAdicionarDocumentosGenerico from '@/views/components/documentos/controle-documentos/modal-adicionar/documentos/ModalAdicionarDocumentosGenerico.vue'
import ModalAdicionarAnexosGenerico from '@/views/components/documentos/controle-documentos/modal-adicionar/anexos/ModalAdicionarAnexosGenerico.vue'
import ModalSelecaoTipoAssinaturaGenerico from '@/views/components/documentos/controle-documentos/assinatura/selecao-tipo/ModalSelecaoTipoAssinaturaGenerico.vue'
import { AzDigitalSignature } from '@azinformatica/loki'
import { LoadingScreen } from '@/core/utils'
import FormularioAssinaturaConvite from '@/views/components/documentos/signatario/convite/FormularioAssinaturaConvite'
import ModalConfirmacao from '@/views/components/ModalConfirmacao'
import ModalAssinaturaSignatario from '@/views/components/documentos/signatario/visualizar/ModalAssinaturaSignatario'

export default {
	name: 'controle-documentos-generico-view',
	components: {
		ModalAssinaturaSignatario,
		ModalConfirmacao,
		FormularioAssinaturaConvite,
		ModalSelecaoTipoAssinaturaGenerico,
		ModalAdicionarAnexosGenerico,
		ModalAdicionarDocumentosGenerico,
		ListagemDocumentos,
		TemplateListagemDocumentosVazia,
	},
	props: {
		hasAuthority: {
			type: Boolean,
		},
		tipoDocumento: {
			type: Object,
			required: true,
		},
		isEditar: {
			type: Boolean,
			default: () => true,
		},
		idPastaExternaDigital: {
			type: String,
			default: () => '',
		},
		repositorioFlowbee: {
			type: String,
			required: true,
		},
		menuAcoesItens: {
			type: Object,
			default: () => {
				return {
					nome: 'Adicionar',
					itens: [
						{
							titulo: 'Documento',
							icone: {
								nome: 'description',
							},
							evento: 'adicionar-documento',
						},
						{
							titulo: 'Anexo',
							icone: {
								nome: 'attach_file',
							},
							evento: 'adicionar-anexo',
						},
					],
				}
			},
		},
		colunaTituloHabilitada: {
			type: Boolean,
			default: () => true,
		},
		colunaDataHabilitada: {
			type: Boolean,
			default: () => true,
		},
		colunaConvidadosHabilitada: {
			type: Boolean,
			default: () => true,
		},
		colunaJuntadoHabilitada: {
			type: Boolean,
			default: () => true,
		},
		usuarioPossuiPermissaoParaJuntar: {
			type: Boolean,
			default: () => true,
		},
		colunaAcoesHabilitada: {
			type: Boolean,
			default: () => true,
		},
		exibirAcoesProcessoDigital: {
			type: Boolean,
			default: true,
		},
		exibirAcoesPncp: {
			type: Boolean,
		},
		permissaoRedigir: { type: String, default: '' },
		permissaoAssinarEletronicamente: { type: String, default: '' },
		permissaoConcluirEdicaoDocumento: { type: String, default: '' },
		permissaoAssinarDigitalmente: { type: String, default: '' },
		permissaoJuntar: { type: String, default: '' },
		permissaoExcluirDocumento: { type: String, default: '' },
		permissaoBaixarDocumento: { type: String, default: '' },
		permissaoConvidarSignatarios: { type: String, default: '' },
		permissaoCancelarDocumento: { type: String, default: '' },
		permissaoDesentranharDocumento: { type: String, default: '' },
		permissaoPncpEnviar: { type: String, default: '' },
		permissaoPncpExcluir: { type: String, default: '' },
	},
	data() {
		return {
			documentos: [],
			totalItens: 0,
			totalPaginas: 0,
			chaveAtualizacaoListagem: 0,
			filtro: {
				tituloOuAutor: {
					default: null,
					value: null,
					label: 'filtro',
				},
			},
			paginacao: paginacaoListagem(['id']),
			exibirModalAdicionarDocumentos: false,
			exibirModalAdicionarAnexos: false,
			exibirModalSelecaoAssinatura: false,
			loadingHelper: new LoadingScreen(this.$store),
			exibirModalConvidarSignatarios: false,
			exibirModalSignatarios: false,
			tituloDocumento: '',
			tituloModal: '',
			idAssociacao: null,
			signatarios: [],
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			exibirModalConfirmacao: false,
			mensagemConfirmacaoModal: '',
			subtituloConfirmacaoModal: '',
			confirmarAcaoModal: () => {},
			fecharAcaoModal: () => {},
		}
	},
	computed: {
		documentosSelecionados() {
			return this.$store.state.modalAssinaturaFlowbee.documentosSelecionados
		},
		temPermissao() {
			return this.hasAuthority
		},
	},
	async mounted() {
		await this.carregarDocumentos()
	},
	methods: {
		async carregarDocumentos() {
			let { itens, totalPages, totalElements } = await this.$store.dispatch(
				actionTypes.DOCUMENTOS.BUSCA_PAGINADA_GENERICA,
				{
					idEntidade: this.$route.params.id,
					filtro: this.filtro,
					paginacao: this.paginacao,
					tipo: this.tipoDocumento,
				},
			)

			if (this.isProcessoDigitalAtivo) this.documentos = await this.buscarSignatariosDocumento(itens)
			else this.documentos = itens

			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async buscar(searchText) {
			this.resetarPaginaListagem()
			this.filtro.tituloOuAutor.value = searchText
			await this.carregarDocumentos()
		},
		async removerFiltros() {
			if (this.filtro.tituloOuAutor.value) {
				this.filtro.tituloOuAutor.value = this.filtro.tituloOuAutor.default
			}
			this.resetarPaginaListagem()
			await this.carregarDocumentos()
		},
		resetarPaginaListagem() {
			this.paginacao.page = 1
		},
		async setPaginacaoListagem(paginacao) {
			this.paginacao = paginacao
			await this.carregarDocumentos()
		},
		adicionarDocumento() {
			this.exibirModalAdicionarDocumentos = true
		},
		adicionarAnexo() {
			this.exibirModalAdicionarAnexos = true
		},
		async fecharModaladicionar() {
			this.exibirModalAdicionarDocumentos = false
			await this.carregarDocumentos()
		},
		async fecharModalAdicionarAnexo() {
			this.exibirModalAdicionarAnexos = false
			await this.carregarDocumentos()
		},
		abrirModalSelecionarTipoAssinatura(doc) {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_DOCUMENTOS, [doc])
			this.exibirModalSelecaoAssinatura = true
		},
		fecharModalSelecionarTipoAssinatura() {
			this.exibirModalSelecaoAssinatura = false
		},
		async tratarEventoCriarTermoDesentranhamento(documento) {
			this.setMensagemLoading('Carregando o termo de desentranhamento...')
			const termoDesentranhamento = await this.$store.dispatch(
				actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO,
				{
					tipo: this.tipoDocumento,
					documento: documento.id,
				},
			)

			await this.redirecionarToProcessoRedigirTermoDesentranhamento(termoDesentranhamento.documento.idAssociacao)
		},
		async tratarEventoContinuarElaboracaoTermoDesentranhamento(documento) {
			await this.redirecionarToProcessoRedigirTermoDesentranhamento(documento.idReferenciaTermoDesentranhamento)
		},
		async redirecionarToProcessoRedigirTermoDesentranhamento(idTermo) {
			const getNomeRotaGenerico = this.tipoDocumento.path.toUpperCase()

			await this.$router.push({
				name: routesNames[getNomeRotaGenerico].PROCESSO_DIGITAL.DESENTRANHAMENTO
					.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					id: this.$route.params.id,
					idTermo,
				},
			})
		},
		async realizarAssinaturaDigital(certificadoThumbprint) {
			const documento = this.getDocumento()
			const assinaturaDigital = new AzDigitalSignature({ store: this.$store })

			try {
				if (documento) {
					this.mostrarMensagemCarregamentoAssinatura()
					await this.validarSeDocumentoFoiAssinadoNoProcessoDigital(documento)
					await assinaturaDigital.sign(certificadoThumbprint, documento.idExternoDocumento)

					await this.$store.dispatch(
						actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE,
						this.getParamsUrlAssinaturaIndividual(documento),
					)

					await this.carregarDocumentos()
					this.mostrarNotificacaoSucessoAoRealizarAssinatura()
					this.loadingHelper.stop()
				}
			} catch (e) {
				this.mostrarNotificacaoErro(e.message)
				this.limparDocumentosAssinatura()
			}
		},
		async realizarAssinaturaEletronica() {
			try {
				this.setMensagemLoading('Assinando documento eletronicamente...')
				await this.$store.dispatch(
					actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
					this.getParamsUrlAssinaturaIndividual(this.getDocumento()),
				)
				await this.carregarDocumentos()
				this.mostrarNotificacaoSucessoAoRealizarAssinatura()
				this.fecharModalSelecionarTipoAssinatura()
			} catch (e) {
				this.mostrarNotificacaoErro(e.message)
				this.limparDocumentosAssinatura()
			}
		},
		async validarSeDocumentoFoiAssinadoNoProcessoDigital(documento) {
			await this.$store.dispatch(
				actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO,
				this.getParamsUrlAssinaturaIndividual(documento),
			)
		},
		limparDocumentosAssinatura() {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.LIMPAR)
		},
		mostrarNotificacaoSucessoAoRealizarAssinatura() {
			this.mostrarNotificacaoSucesso('Documento assinado com sucesso.')
		},
		mostrarMensagemCarregamentoAssinatura() {
			this.setMensagemLoading('Assinando documento...')
			this.loadingHelper.start()
		},
		getDocumento() {
			return this.documentosSelecionados.length === 1
				? this.documentosSelecionados[0]
				: this.documentosSelecionados
		},
		getParamsUrlAssinaturaIndividual(documento) {
			return {
				tipo: this.tipoDocumento,
				documento: documento.id,
			}
		},
		buscarSignatarios(idDocumento) {
			return this.$store.dispatch(actionTypes.DOCUMENTOS.SIGNATARIOS.BUSCAR_SIGNATARIOS, {
				idDocumento,
				tipo: this.tipoDocumento,
			})
		},
		fecharModalSignatarios() {
			this.signatarios = []
			this.exibirModalSignatarios = false
		},
		async tratarEventoVisualizarSignatarios(idDocumento) {
			const documento = this.documentos.find((documento) => documento.id === idDocumento)
			this.signatarios = documento.signatarios.itens
			this.exibirModalSignatarios = true
			this.tituloModal = 'Signatários'
		},
		async convidarSignatarios(emailsSignatarios) {
			await this.$store.dispatch(actionTypes.DOCUMENTOS.SIGNATARIOS.CONVIDAR_SIGNATARIOS, {
				idDocumento: this.idAssociacao,
				emailsSignatarios,
				tipo: this.tipoDocumento,
			})
			const documento = this.documentos.find((documento) => documento.id === this.idAssociacao)
			const documentoSignatario = await this.buscarSignatariosDocumento([documento])
			this.$set(this.documentos, this.documentos.indexOf(documento), documentoSignatario[0])
			this.mostrarNotificacaoSucesso('Signatários Convidados com Sucesso')
			this.fecharModal()
		},
		async buscarSignatariosDocumento(documentos) {
			let novoArray = []
			if (!documentos) return novoArray

			for (const documento of documentos) {
				if (documento.situacao && documento.situacao !== situacoes.DOCUMENTO.CRIADO.value) {
					const resultado = await this.$store.dispatch(
						actionTypes.DOCUMENTOS.SIGNATARIOS.BUSCAR_SIGNATARIOS,
						{
							idDocumento: documento.id,
							tipo: this.tipoDocumento,
						},
					)
					const documentoNovo = Object.assign({}, documento, {
						signatarios: resultado,
					})
					novoArray.push(documentoNovo)
				} else {
					novoArray.push(documento)
				}
			}

			return novoArray
		},
		fecharModal() {
			this.exibirModalConvidarSignatarios = false
		},
		tratarEventoExcluirSignatario({ idAssociacao, signatario }) {
			this.exibirModalConvidarSignatarios = false
			this.idAssociacao = idAssociacao
			this.emailSignatarioExclusao = signatario.email
			this.tituloModal = 'Atenção! Deseja excluir este signatário?'
			this.mensagemConfirmacaoModal =
				'Após a confirmação, o signatário será excluído e não poderá assinar o documento!'
			this.confirmarAcaoModal = this.excluirSignatario
			this.cancelarAcaoModal = this.cancelarAcaoExcluirSignatario
			this.fecharAcaoModal = this.cancelarAcaoExcluirSignatario
			this.exibirModalConfirmacao = true
		},
		tratarEventoConvidarSignatarios({ idAssociacao, titulo }) {
			this.idAssociacao = idAssociacao
			this.exibirModalConvidarSignatarios = true
			this.tituloModal = 'Convite'
			this.tituloDocumento = titulo
		},
		async excluirSignatario() {
			await this.$store.dispatch(actionTypes.DOCUMENTOS.SIGNATARIOS.EXCLUIR, {
				idDocumento: this.idAssociacao,
				emailsSignatarios: this.emailSignatarioExclusao,
				tipo: this.tipoDocumento,
			})
			this.mostrarNotificacaoSucesso('Signatário excluido com sucesso')
			this.exibirModalConvidarSignatarios = false
			const documento = this.getDocumentoPorPropriedade('id', this.idAssociacao)
			const documentoSignatario = await this.buscarSignatariosDocumento([documento])
			this.$set(this.documentos, this.documentos.indexOf(documento), documentoSignatario[0])
			this.tratarEventoConvidarSignatarios({ idAssociacao: this.idAssociacao, titulo: this.tituloDocumento })
			this.cancelarAcaoExcluirSignatario()
		},
		getDocumentoPorPropriedade(propriedade, valor) {
			return this.documentos.find((documento) => documento[propriedade] === valor)
		},
		cancelarAcaoExcluirSignatario() {
			this.exibirModalConfirmacao = false
			this.tratarEventoConvidarSignatarios({ idAssociacao: this.idAssociacao, titulo: this.tituloDocumento })
		},
	},
}
</script>
